const PENDING_KEY = 'bel_verification_pending';
const STALE_MS = 30 * 24 * 60 * 60 * 1000; // ignore a forgotten flag after 30 days
const STEP_NAMES = { 1: 'account', 2: 'apply', 3: 'verify', 4: 'shop' };

const OneVerification = {

	init: function (settings) {
		if (this._initialized) return;
		this._initialized = true;

		this.marketing = (settings && settings.marketing) || ORW.marketing;
		this.state = ORW.verification;
		if (!this.marketing || !this.state) return;

		// Cross-page bridge first: resolve any pending verification (success/abandon).
		this.resolvePending();

		// On the beautyalist page: emit the current funnel stage (+ gate at step 3).
		if (this.state.isBeautyalistPage) {
			this.trackStage();
		}

		// Attempt: delegated so it survives the BeautyAList embed rewriting the button.
		this.bindAttempt();
	},

	/* --- helpers --- */

	getPending: function () {
		try {
			var raw = localStorage.getItem(PENDING_KEY);
			if (!raw) return null;
			var data = JSON.parse(raw);
			if (!data || (data.ts && (Date.now() - data.ts) > STALE_MS)) {
				localStorage.removeItem(PENDING_KEY);
				return null;
			}
			return data;
		} catch (e) {
			return null;
		}
	},

	clearPending: function () {
		try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
	},

	// Single send point so the debug toggle can log every event consistently.
	push: function (eventName, params) {
		if (this.state.debug) {
			console.log('%c[verification]%c ' + eventName, 'color:#f95651;font-weight:700', 'color:inherit', params);
		}
		this.marketing.pushEvent(eventName, params);
	},

	// Authoritative step from the tracker's data-step, falling back to derived state.
	currentStep: function () {
		var tracker = document.querySelector('.beautyalist-tracker[data-step]');
		if (tracker) {
			var n = parseInt(tracker.dataset.step, 10);
			if (n >= 1 && n <= 4) return n;
		}
		if (!this.state.loggedIn) return 1;
		if (!this.state.stylistType) return 2;
		if (!this.state.isVerified) return 3;
		return 4;
	},

	gateShown: function () {
		return !!(this.state.isBeautyalistPage && document.querySelector('.action_blist'));
	},

	payload: function (step, stylistType) {
		return {
			funnel: 'beautyalist',
			step: step,
			step_name: STEP_NAMES[step] || null,
			logged_in: !!this.state.loggedIn,
			stylist_type: (stylistType || this.state.stylistType) || null
		};
	},

	/* --- events --- */

	trackStage: function () {
		var step = this.currentStep();
		this.push('dl_verification_step', this.payload(step));
		// "Gate hit" = the verification gate is actually on screen (step 3 button present).
		if (this.gateShown()) {
			this.push('dl_verification_gate', this.payload(3));
		}
	},

	bindAttempt: function () {
		// Bellami auto clicks into beautyalist login, no need to track button click
		var self = this;
		if (!!self.state.loggedIn && !self.state.isVerified) {
			this.push('dl_verification_start', this.payload(3));
			try {
				localStorage.setItem(PENDING_KEY, JSON.stringify({
					ts: Date.now(),
					stylistType: self.state.stylistType || ''
				}));
			} catch (err) {}
		}
		// var self = this;
		// document.addEventListener('click', function (e) {
		// 	var btn = e.target.closest && e.target.closest('#beautyalist_login, #beautyalist_openid');
		// 	if (!btn) return;
		// 	self.push('dl_verification_start', self.payload(3));
		// 	// Write the bridge flag synchronously, before the redirect/popup navigates away.
		// 	try {
		// 		localStorage.setItem(PENDING_KEY, JSON.stringify({
		// 			ts: Date.now(),
		// 			stylistType: self.state.stylistType || ''
		// 		}));
		// 	} catch (err) {}
		// });
	},

	resolvePending: function () {
		var pending = this.getPending();
		if (!pending) return;

		// Success: came back (anywhere) now verified. Evaluate before abandon.
		if (this.state.isVerified) {
			this.push('dl_verification_complete', this.payload(4, pending.stylistType));
			this.clearPending();
			return;
		}

		// Still on the active gate (can retry) → keep the flag, do not fire abandon.
		if (this.gateShown()) return;

		// Abandon: pending, not verified, and no longer on the verify gate.
		this.push('dl_verification_abandon', this.payload(3, pending.stylistType));
		this.clearPending();
	}
};

export default OneVerification;
